import { observer } from "mobx-react";
import { FontProps, FONT_COLOR, FONT_VARIANT } from "../components/fonts/font-props";
import useTranslation from "./hooks/translation-hook";

interface IProps {
    translationKey: string;
    Font:React.FC<FontProps>;
    variant?: FONT_VARIANT | FONT_VARIANT[];
    color?: FONT_COLOR;
}

const Translation = observer(({ translationKey, Font, variant, color }: IProps) => {
    const { getTranslation } = useTranslation();

    return (
        <Font color={color} variant={variant}>
            {getTranslation(translationKey)}&nbsp;
        </Font>
    );
});

export default Translation;
